import { bus } from "../../main";
import { mapGetters } from "vuex";
export const sidebarMixin = {
    data: function () {
        return {
            currentElementValue: {},
            currentIndex: "",
            currentValue: "",
        }
    },
    computed: {
        ...mapGetters({
            getMainInfo: "profile/getMainInfo",
        }),
    },
    methods: {
        showField() {
            if (this.structure.hasOwnProperty("showWhen")) {
                const showWhen = Object.entries(this.structure.showWhen);

               
                //currentElementValue = the current element that trigger the user
                //ex: a radio element currentElementValue.inde is the name of the element like :fomrType
                //this.currentElementValue.value : ex: popup
                //then we match it to all field that has showWhen property
                //show when property can be multiple so we nee to check if it has "|" char then we split and loop
                //otherwise we just compare the value straigthaway.

               
                for (const [elementName, value] of showWhen) {
                  
                    if (this.currentElementValue.value != undefined && this.currentElementValue.value != "") {
                     
                        this.currentIndex = this.currentElementValue.index;
                        this.currentValue = this.currentElementValue.value
                    } else {
                        if (this.getMainInfo.hasOwnProperty(elementName)) {
                            this.currentIndex = elementName;
                            this.currentValue = this.getMainInfo[elementName];
                        }
                    }

                    if (this.currentIndex == elementName) {
                        if (value.includes("|")) {
                            //WE NEED TO CHECK IF IT HAS MULTIPLE VALUES
                            this.tempArray = value.split("|"); //IF IT DOES WE SPLIT IT
                            for (var i = 0, len = this.tempArray.length; i < len; i++) {
                              
                                if (this.tempArray[i] == this.currentValue) {
                               
                                    this.currentValueOfShowHideField = true;
                                    return true;

                                }
                            }
                        } else {
                          
                            if (value == this.currentValue) {
                            
                                this.currentValueOfShowHideField = true;
                                return true;
                            }
                        }
                    } else {
                        return this.currentValueOfShowHideField;
                    }
                }
            } else {
                return true;
            }
        }
    },
    created() {
        bus.$on("showHideField", data => {
            this.currentElementValue = data;
            this.showField;
            this.showFieldOnLoad;
        });
    },
    beforeDestroy() {
        bus.$on("showHideField", data => {
            this.currentElementValue = data;
            this.showField;
        });
    }


};